// extracted by mini-css-extract-plugin
export default {"slider":"SliderWrapper_slider__IK14j","sliderTitle":"SliderWrapper_sliderTitle__Ppq9u","sliderWrapper":"SliderWrapper_sliderWrapper__yyfPg"};